/* FounderNote — used in empty-state cards on Path Stories and Outcomes.
   Honest, real, single-author voice. Not a fake testimonial.
*/
import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';

const FounderNote = ({ ctaLabel = 'Read why I started LearnixTa', ctaHref = '/about', compact = false }) => (
  <div
    className={`relative bg-white rounded-3xl border-2 border-gray-200 ${compact ? 'p-5' : 'p-6 md:p-8'} max-w-3xl mx-auto`}
    data-testid="founder-note"
  >
    <span className="absolute -top-3 left-6 inline-flex items-center gap-1.5 text-[10px] font-extrabold tracking-widest uppercase bg-gray-900 text-white px-2.5 py-1 rounded-full">
      <Quote size={11} /> Founder note · not a testimonial
    </span>
    <div className="flex items-start gap-4 mt-2">
      <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-teal-500 to-emerald-600 text-white font-extrabold flex items-center justify-center shrink-0">L</span>
      <div className="flex-1 min-w-0">
        <p className="text-[14px] md:text-[15px] text-gray-800 leading-relaxed">
          Hi — I&rsquo;m the founder of LearnixTa, building this solo from Hyderabad. I&rsquo;ve seen too many students in Telangana and AP get pushed into careers they didn&rsquo;t choose, with debt and a degree they don&rsquo;t use. So I&rsquo;m doing something boring on purpose: <strong>I refuse to publish a single testimonial until a real student earns one.</strong>
        </p>
        <p className="text-[14px] md:text-[15px] text-gray-800 leading-relaxed mt-3">
          This space is empty for the same reason a fresh notebook is empty. The first verified story changes that — and might be yours.
        </p>
        <div className="mt-3 text-xs text-gray-500">— L., LearnixTa</div>
        {ctaLabel && (
          <Link
            to={ctaHref}
            data-testid="founder-note-cta"
            className="inline-flex items-center gap-1.5 mt-4 text-sm font-bold text-teal-700 hover:text-teal-900"
          >
            {ctaLabel} <ArrowRight size={14} />
          </Link>
        )}
      </div>
    </div>
  </div>
);

export default FounderNote;
